/// <amd-module name="Wit/Common/AgileControls/AgileContracts" />
import { ExceptionInfo } from "Wit/Common/HubError/Models/Models";

export interface IBacklogsHubContentHeaderData {
    allBacklogLevels: IBacklogLevelConfiguration[];
    backlogId: string;
    hasIterations: boolean;
    newBacklogLevelsSignature: string;
    requirementLevelName: string;
    teamId: string;
    teamName: string;
    visibleBacklogLevels: IBacklogLevelConfiguration[];
    exceptionInfo: ExceptionInfo;
}

export interface IBoardsHubContentHeaderData {
    allBacklogLevels: IBacklogLevelConfiguration[];
    backlogId: string;
    hasIterations: boolean;
    newBacklogLevelsSignature: string;
    requirementLevelName: string;
    visibleBacklogLevels: IBacklogLevelConfiguration[];
    exceptionInfo: ExceptionInfo;
}

export interface IBacklogLevelConfiguration {
    addPanelFields: string[];
    color: string;
    columnFields: IBacklogColumn[];
    custom: boolean;
    defaultWorkItemType: string;
    id: string;
    isRequirementsBacklog: boolean;
    isTaskBacklog: boolean;
    name: string;
    rank: number;
    workItemCountLimit: number;
    workItemTypes: string[];
}

export interface IBacklogColumn {
    columnReferenceName: string;
    notAField: boolean;
    rollup: boolean;
    rollupCalculation: IRollupCalculation;
    width: number;
}

export interface IRollupCalculation {
    aggregation: RollupAggregation;
    aggregationField: string;
    backlogFilter: string;
    type: RollupType;
    workItemTypeFilter: string;
}

export enum RollupAggregation {
    Count = 0,
    Sum = 1
}

export enum RollupType {
    Progress = 0,
    Total = 1
}
